import { Component, OnInit } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { MatAccordion, MatExpansionPanelActionRow } from '@angular/material/expansion';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { Logger } from '../../../infrastructure/logging/logger';
import { PropertyFormService } from './services/property-form.service';
import { PropertyFormBasicInformationComponent } from './components/property-form-basic-information/property-form-basic-information.component';
import { PropertyFormAddressComponent } from './components/property-form-address/property-form-address.component';
import { PropertyFormPhotosComponent } from './components/property-form-photos/property-form-photos.component';
import { PropertyFormHomeownerComponent } from './components/property-form-homeowner/property-form-homeowner.component';
import { BackButtonComponent } from '../../../shared/components/back-button/back-button.component';
import { OrganizationService } from '../../organizations/services/organizations.service';
import { Organization } from '../../organizations/models/Organization';

@Component({
  selector: 'app-property-form',
  templateUrl: './property-form.component.html',
  styleUrls: ['./property-form.component.scss'],
  providers: [ PropertyFormService ],
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinner,
    MatIcon,
    MatAccordion,
    PropertyFormBasicInformationComponent,
    PropertyFormAddressComponent,
    PropertyFormPhotosComponent,
    PropertyFormHomeownerComponent,
    MatExpansionPanelActionRow,
    AsyncPipe,
    RouterModule,
    MatButtonModule,
    BackButtonComponent
  ]
})
export class PropertyFormComponent implements OnInit {

  selectedOrganizationId: any;
  organizationId!: number | string;
  organizations!: Organization[];

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly logService: Logger,
    public propertyFormService: PropertyFormService,
    private organizationService: OrganizationService
  ) { }

  ngOnInit() {
    this.propertyFormService.error$.subscribe(error => {
      this.logService.handleError(error, 'An error occurred while retrieving Property form', 'Error while retrieving Property form');
    });

    this.propertyFormService.saveCompleted$.subscribe(propertyId => {
      this.navigateToPropertyDetailPage(propertyId);
    });

    this.storePropertyId();
    this.getOrganizations();
  }

  storePropertyId() {
    const propertyId = this.getPropertyIdFromUrl();
    this.propertyFormService.load(Number(propertyId));
  }

  async getOrganizations() {
    const orgResponse = await this.organizationService.getOrganizations();
    this.organizations = orgResponse.sort((a,b) => (a.organization_name > b.organization_name) ? 1 : ((b.organization_name > a.organization_name) ? -1 : 0));
  }

  getPropertyIdFromUrl() {
    return this.route.snapshot.queryParamMap.get('propertyId');
  }

  getOrganizationIdFromUrl() {
    return this.route.snapshot.queryParamMap.get('organizationId');
  }

  navigateToPropertyDetailPage(propertyId: number) {
    this.router.navigate([`/properties/detail/${propertyId}`]);
  }

  getSelectedOrgPolicies(orgId: number) {
    this.organizationId = orgId;
  }

  async submitProperty() {
    this.propertyFormService.saveProperty(Number(this.organizationId));
  }
}